export default "__VITE_ASSET__CohPh$14__"